import React, { Fragment } from "react";
import { useParams } from "react-router-dom";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import ProductDetailsContent from "./ProductDetailsContent";
import products from "../../api/productData";
import SEO from "../../components/SEO/SEO";

const ProductDetailPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const product = products.find((p) => p.slug === slug);

  if (!product) {
    return (
      <Fragment>
        <SEO title="Product Not Found | TorqAI" description="The product you are looking for does not exist." />
        <div className="about-page inner-page">
          <div className="body_wrap o-clip">
            <Header />
            <main>
              <PageTitle pageTitle="Product Not Found" pagesub="Products" />
              <section className="service-details pos-rel">
                <div className="container" style={{ padding: "100px 0", textAlign: "center" }}>
                  <h2>Product not found</h2>
                  <p>The product you're looking for doesn't exist.</p>
                </div>
              </section>
            </main>
            <Footer />
            <Scrollbar />
          </div>
        </div>
      </Fragment>
    );
  }

  const schema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": `TorqAI ${product.name}`,
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Web-based",
    "description": product.subtitle || `TorqAI ${product.name} - Intelligent digital worker.`,
    "offers": {
      "@type": "Offer",
      "price": "199.00",
      "priceCurrency": "CAD"
    }
  };

  return (
    <Fragment>
      <SEO 
        title={`TorqAI ${product.name} | Intelligent AI Digital Worker`}
        description={product.subtitle || `Scale your business with TorqAI ${product.name}, our advanced intelligent digital worker.`}
        canonicalUrl={`https://torqai.ca/products/${product.slug}`}
        schema={schema}
      />
      <div className="about-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle pageTitle={product.name} pagesub="Products" />
            <ProductDetailsContent product={product} />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default ProductDetailPage;
